<template>
  <!--      menu -->
  <div class="lg:block hidden px-1 w-full">
    <div class="text-cerise-red-600 mt-0 text-3xl leading-9 justify-center">
      <h1 class="">Benvenuto/a &nbsp</h1>
      <h1 class="font-extrabold">{{ user }}</h1>
    </div>
    <div class="mt-6 border border-alto-300 rounded-sm divide-y">
      <template v-for="tab in tabs" :key="tab.title">
        <nuxt-link
          :to="tab.path"
          :target="tab?.target ?? '_self'"
          class="py-4 px-1 flex gap-3 items-center leading-5 lg:pl-10 text-black font-normal hover:cursor-pointer hover:font-bold hover:text-cerise-red-600"
          active-class="!text-cerise-red-600 !font-bold"
        >
          {{ tab.title }}

          <span v-if="tab?.target === '_blank'">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.2rem"
              height="1.2rem"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="#e72b6f"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6m-7 1l9-9m-5 0h5v5"
              />
            </svg>
          </span>
          <span v-if="tab?.isNew">
            <nuxt-img src="/images/new-label.png" class="w-8" />
          </span>
        </nuxt-link>
      </template>
    </div>
  </div>

  <!--      mobile menu -->
  <div class="text-center lg:hidden block px-1 w-full">
    <div class="text-cerise-red-600 flex text-xl leading-6 justify-center">
      <h1 class="">Benvenuto/a &nbsp</h1>
      <h1 class="font-extrabold">{{ user }}</h1>
    </div>
    <div
      class="mt-4 border border-alto-300 rounded-sm"
      :class="{ 'divide-y': expandTabsMenu }"
    >
      <template v-for="tab in tabs" :key="tab.title">
        <nuxt-link
          :to="tab.path"
          @click="expandTabsMenu = !expandTabsMenu"
          :target="tab?.target ?? '_self'"
          class="py-4 flex items-center text-black font-normal"
          :class="{ hidden: !expandTabsMenu }"
          active-class="!text-cerise-red-600 !font-bold !flex"
        >
          <nuxt-img
            src="/images/ios-menu.svg"
            class="lg:hidden block bg-transparent w-7 ml-7"
            v-if="route.path === tab.path && !expandTabsMenu"
          />
          <div
            :class="route.path === tab.path && !expandTabsMenu ? 'pr-14' : ''"
            class="leading-5 mx-auto flex gap-3 items-center"
          >
            <span v-if="tab?.isNew">
              <nuxt-img src="/images/new-label.png" class="w-fit" />
            </span>
            <span v-if="tab?.target === '_blank'">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.2rem"
                height="1.2rem"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="#e72b6f"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6m-7 1l9-9m-5 0h5v5"
                />
              </svg>
            </span>
            {{ tab.title }}
          </div>
        </nuxt-link>
      </template>
    </div>
  </div>
</template>

<script setup>
import { useProfile } from "~/store/profile";

const { data } = useAuth();
const user = computed(() => data?.value?.user?.name || "Utente");

const profileStore = useProfile();
await profileStore.getProfile();

const expandTabsMenu = ref(false);

const config = useRuntimeConfig().public;

const tabs = ref([
  {
    title: "La tua card",
    path: "/profile",
  },
  {
    title: "I tuoi dati",
    path: "/profile/update",
  },
  {
    title: "I tuoi badges",
    path: "/profile/badges",
  },
  {
    title: "I tuoi servizi",
    path: "/profile/services",
    isNew: "true",
  },
  {
    title: "I tuoi buoni sconto",
    path: "/profile/coupon",
    isNew: "true",
  },
  {
    title: "Offerte esclusive",
    path: "/profile/offers",
  },
  {
    title: "Invita un amico",
    path: "/profile/invite",
  },
  {
    title: "Storico acquisti",
    path: "/profile/purchases",
  },
  {
    title: "Gestione ordini online",
    path: "https://prenatal.com/my-account",
    target: "_blank",
  },
  {
    title: "Parental Skills @ Work",
    path: config.pntSkillsAtWork,
    target: "_blank",
  },
]);


if (profileStore.isVip) {
  tabs.value = tabs.value.filter(
    (t) => !["/profile/services"].includes(t.path)
  );
} else {
  tabs.value = tabs.value.filter((t) => !["/profile/badges"].includes(t.path));
}

let route = useRoute();
</script>
